<template>
    <ui-table
            url="/employee/list"
            :search="query"
            @onReset="onReset"
            ref="table"
            isNeedIndex
            @handleSelectionChange="handleSelectionChange">
        <template #search-content>
            <el-form
                    ref="ruleFormRef"
                    :model="query"
                    label-width="120px"
                    :inline="true"
                    class=""
            >
                <el-form-item label="姓名">
                    <el-input v-model="query.name" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
            </el-form>
        </template>
        <template #btn>
            <el-button class="filter-item" icon="Plus" @click="handleClick_add()">新增</el-button>
        </template>
        <template #column>
            <el-table-column prop="name" label="姓名" show-overflow-tooltip	/>
            <el-table-column prop="account" label="账号" show-overflow-tooltip	/>
            <el-table-column prop="deparment_id" label="部门" show-overflow-tooltip	/>
            <el-table-column prop="signature" label="个性签名" show-overflow-tooltip	/>
            <el-table-column prop="email" label="邮箱" show-overflow-tooltip	/>
            <el-table-column prop="create_time" label="发布时间" />
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button type="text" @click="handleClick_edit(scope.row.id)">修改</el-button>
                    <el-popconfirm title="确定要删除此商品吗" @confirm="handleClick_delete(scope.row.id)">
                        <template #reference>
                            <el-button type="text">删除</el-button>
                        </template>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </template>
    </ui-table>
    <addOrEdit :isShow="isShow" v-if="isShow" ref="addOrEditRef" @closeDialog="closeDialog" @refreshDataList="refresh"></addOrEdit>
</template>

<script>
    import { defineComponent, onMounted, reactive,ref, nextTick, unref} from 'vue';
    import { ElMessage,ElMessageBox  } from 'element-plus/lib/components';
    import addOrEdit from './addOrEdit'
    import {delHandle} from '@/api/employee'
    export default defineComponent({
        name:'dealerManager',
        components:{
            addOrEdit
        },
        setup(){
            let data = ref([])
            let isShow = ref()
            let query = reactive({
                title:'',
                istop:'',
                type:""
            })
            let outerVisible = ref(false)
            let dialogTitle = ref('新增')
            let currentDealerId
            let currentRow = {}
            let isEdit = false
            let delIds = ref([])
            let form = reactive(
                {
                    phone:''
                }
            )
            const table = ref(null)
            function refresh(){
                table.value.getList()
            }
            function editDialog(row){//编辑
                outerVisible.value = true
                currentDealerId = row.id
                currentRow = row
                isEdit = true
                dialogTitle.value = '修改'
            }
            const addOrEditRef = ref()
            function closeDialog(){
                isShow.value = false
            }
            function handleClick_add(){
                isShow.value = true
                nextTick( () => {
                    addOrEditRef.value.init()
                })

            }
            function handleClick_edit(id){
                isShow.value = true
                nextTick( () => {
                    addOrEditRef.value.init(id)
                })

            }
            function handleSelectionChange(val){//多选
                delIds.value = []
                val.map(item=>{
                    delIds.value.push(item.id)
                })
            }
            function handleClick_delete(id){
                console.log(id)
                delHandle({id:id}).then((data) => {
                    if(data.code == 200){
                        ElMessage({
                            showClose: true,
                            message: '删除成功',
                            type: 'success',
                        })
                        refresh()
                    }else{
                        ElMessage({
                            showClose: true,
                            message: data.message,
                            type: 'warning',
                        })
                    }
                })
            }
            function onReset(){//重置
                // let form = unref(ruleFormRef)
                // ruleFormRef.value.resetFields()
                query.factory = ''
                query.onSale=''
                query.nameOrCode=''
            }

            function goodsStatus(id,status){
                let title
                if(status=='Y'){
                    title = '确定要上架这款商品吗?'
                }else{
                    title = '确定要下架这款商品吗?'
                }
                ElMessageBox.confirm(
                    title,
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                )
                    .then(() => {
                        goodStatus({id:id,status:status}).then(data => {
                            ElMessage({
                                type: 'success',
                                message: '操作成功',
                            })
                            refresh()
                        })
                    })
                    .catch(() => {
                        // ElMessage({
                        //     type: 'info',
                        //     message: 'Delete canceled',
                        // })
                    })
            }
            onMounted(()=>{

            })
            return {
                dialogTitle,
                data,
                query,
                outerVisible,
                form,
                isShow,
                editDialog,
                handleSelectionChange,
                onReset,
                handleClick_add,
                handleClick_edit,
                closeDialog,
                refresh,
                handleClick_delete,
                goodsStatus,
                addOrEditRef,
                table

            }
        }
    })

</script>
<style lang="scss" scoped>
    .demo-form-inline{
        .el-form-item{
            width: 40%;
        }
    }
    .el-dialog{
        .search-area{
            width:100%;
            display: flex;
            flex-wrap: wrap;
            .search-item{
                margin-bottom:15px;
                span{
                    display: inline-block;
                    width:100px;
                    text-align: right;
                }
                .el-input{
                    width:200px;
                    margin-right: 15px;
                }
            }
        }
        .page-area{
            margin-top:20px;
            display: flex;
            justify-content: flex-end;
        }
    }

</style>
